import React from "react";

import { isOpinionItem } from "~models/transforms/eyebrow";
import {
    type CuratedItem,
    CuratedItemVariation,
    getByline,
    getCredits,
} from "~types/types";
import { shouldShowByline } from "~utils/shouldShowByline";

import Byline from "../byline/Byline";
import { OpinionByline } from "../opinion-byline/OpinionByline";

type PhoenixBylineProps = {
    story: CuratedItem;
    forceShowByline?: boolean;
};

export default function PhoenixByline({
    story,
    forceShowByline = false,
}: PhoenixBylineProps) {
    if (
        story.variation === CuratedItemVariation.WithoutByline ||
        story.variation === CuratedItemVariation.FeaturedWithoutByline ||
        story.variation === CuratedItemVariation.TextOverImageWithoutByline
    ) {
        return null;
    }

    const byline = getByline(story);
    const credits = getCredits(story);
    const isOpinionStory = isOpinionItem(story);

    if (
        !forceShowByline &&
        !shouldShowByline(story.variation, isOpinionStory)
    ) {
        return null;
    }

    if (isOpinionStory) {
        return <OpinionByline credits={credits} />;
    }

    return <Byline byline={byline} />;
}
